/**
 * SOLITAIRE HOME ELEGANCE - THEME ENGINE
 * Shopify Native AJAX Cart, Mobile Nav, Variant Switchers & Swatches
 */

document.addEventListener('DOMContentLoaded', () => {
  // Mobile Navigation Drawer
  const mobileToggle = document.getElementById('mobileNavToggle');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const mobileClose = document.getElementById('mobileDrawerClose');

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', () => {
      mobileDrawer.classList.add('active');
    });
  }
  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', () => {
      mobileDrawer.classList.remove('active');
    });
  }

  // Cart Drawer Mechanics
  const cartDrawer = document.getElementById('solitaire-cart-drawer');
  const cartOpenBtn = document.getElementById('openCartDrawerBtn');
  const cartCloseBtn = document.getElementById('cartDrawerCloseBtn');
  const cartOverlay = document.getElementById('cartDrawerCloseOverlay');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  if (cartOpenBtn) {
    cartOpenBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  }
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // AJAX Cart Form Submission
  const productForm = document.getElementById('SolitaireProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = document.getElementById('SelectedVariantId').value;
      const quantity = parseInt(document.getElementById('ProductQuantity').value || 1, 10);
      const submitBtn = document.getElementById('AddToCartBtn');
      const originalText = submitBtn.innerHTML;

      submitBtn.innerHTML = '<span>Curating...</span>';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });

        if (response.ok) {
          await refreshCartState();
          openCart();
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('Add to cart error:', err);
        window.location.href = '/cart';
      } finally {
        submitBtn.innerHTML = originalText;
      }
    });
  }

  // Quick Add Buttons
  document.querySelectorAll('.quick-add-btn').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const origText = btn.textContent;
      btn.textContent = 'Curating...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (response.ok) {
          await refreshCartState();
          openCart();
        }
      } catch (err) {
        console.error('Quick add error:', err);
      } finally {
        btn.textContent = origText;
      }
    });
  });

  // Quantity Stepper
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  const qtyInput = document.getElementById('ProductQuantity');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  // Refresh Cart Drawer State via /cart.js
  async function refreshCartState() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const badge = document.getElementById('cartCountBadge');
      if (badge) badge.textContent = cart.item_count;

      const drawerCount = document.getElementById('drawerItemCount');
      if (drawerCount) drawerCount.textContent = `(${cart.item_count})`;

      const subtotal = document.getElementById('cartDrawerSubtotal');
      if (subtotal) subtotal.textContent = `$${(cart.total_price / 100).toFixed(2)}`;

      const itemsContainer = document.getElementById('cartDrawerItems');
      if (itemsContainer && cart.items.length > 0) {
        itemsContainer.innerHTML = cart.items.map(item => `
          <div class="cart-drawer__item">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item__image">` : ''}
            <div class="cart-item__details">
              <h5 class="cart-item__title">${item.product_title}</h5>
              <p class="cart-item__variant">${item.variant_title || ''}</p>
              <div class="cart-item__price">$${(item.final_line_price / 100).toFixed(2)}</div>
              <div class="cart-item__quantity-wrap">
                <span class="drawer-qty-val">Qty: ${item.quantity}</span>
              </div>
            </div>
          </div>
        `).join('');
      }
    } catch (err) {
      console.error('Cart state refresh error:', err);
    }
  }

  // Product Gallery Switcher
  const mainImg = document.getElementById('ProductFeaturedMedia');
  document.querySelectorAll('.thumb-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (mainImg && btn.dataset.targetUrl) {
        mainImg.src = btn.dataset.targetUrl;
      }
    });
  });

  // Swatch Dossier Cards
  document.querySelectorAll('.swatch-card').forEach(card => {
    card.addEventListener('click', () => {
      document.querySelectorAll('.swatch-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
    });
  });
});
